@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.refresh {
  padding: 0.5rem 0.55rem;
}

.spinning {
  animation: spin 0.6s ease-in-out;
  transform-origin: 50% 50%;
  display: inline-block;
  width: 22px;
  height: 22px;
}
